import { render, staticRenderFns } from "./PedidosListaAdm.vue?vue&type=template&id=3d1e4dfd&scoped=true&"
import script from "./PedidosListaAdm.vue?vue&type=script&lang=js&"
export * from "./PedidosListaAdm.vue?vue&type=script&lang=js&"
import style0 from "./PedidosListaAdm.vue?vue&type=style&index=0&id=3d1e4dfd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1e4dfd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
